import { useState, useEffect, useRef } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import ScrollToTop from '../Common/ScrollToTop'
import WhatsAppButton from '../WhatsApp/WhatsAppButton'
import EnquiryModal from '../Enquiry/EnquiryModal'

const Layout = () => {
    const [isAutoPopupOpen, setIsAutoPopupOpen] = useState(false)
    const hasShownPopupRef = useRef(false)

    useEffect(() => {
        // If user has already filled the form (persisted across sessions), never show
        if (localStorage.getItem('counsellingFilled') === 'true') return

        let scrollTimer = null

        const handleScroll = () => {
            // Only trigger once per page load
            if (hasShownPopupRef.current) return

            // Clear any existing timer
            if (scrollTimer) clearTimeout(scrollTimer)

            // Start 5-second countdown after scroll
            scrollTimer = setTimeout(() => {
                if (!hasShownPopupRef.current) {
                    hasShownPopupRef.current = true
                    setIsAutoPopupOpen(true)
                }
            }, 5000)
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
            if (scrollTimer) clearTimeout(scrollTimer)
        }
    }, [])

    const handleAutoPopupClose = () => {
        setIsAutoPopupOpen(false)
        // Mark as shown so it doesn't open again in this session (until refresh)
        hasShownPopupRef.current = true
    }

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <ScrollToTop />
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppButton />

            {/* Auto Counselling Popup */}
            <EnquiryModal
                isOpen={isAutoPopupOpen}
                onClose={handleAutoPopupClose}
                enquiryType="consultation"
            />
        </div>
    )
}

export default Layout
